<!-- 物流运输单提货信息部分 -->
<template>
  <div class="transportForm">
    <el-form
      :model="transportData"
      :rules="transportDataRules"
      ref="transportForm"
      label-width="120px"
      :disabled="status == '3' || status == '4'"
    >
      <el-row>
        <el-col :span="6">
          <el-form-item
            :label="this.$t('transportOrderAdd.transportForm.carrierName')"
            prop="carrierName"
          >
            <search-table
              v-model="transportData.carrierName"
              searchType="supplier"
              :isMultiple="true"
              :currentValue="transportData.carrierName"
              @input="setSearchModal"
              @inputReadOnly="setSearchModalInput"
              :isReadOnly="false"
            ></search-table>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="this.$t('transportOrderAdd.transportForm.deliveryProductNo')"
            prop="deliveryProductNo"
          >
            <el-input
              :placeholder="this.$t('transportOrderAdd.transportForm.deliveryProductNoPlaceholder')"
              v-model="transportData.deliveryProductNo"
              clearable
              maxlength="32"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="this.$t('transportOrderAdd.transportForm.deliveryContactPerson')"
            prop="deliveryContactPerson"
          >
            <el-input
              :placeholder="
                this.$t('transportOrderAdd.transportForm.deliveryContactPersonPlaceholder')
              "
              v-model="transportData.deliveryContactPerson"
              clearable
              maxlength="32"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="this.$t('transportOrderAdd.transportForm.deliveryContactTelephone')"
            prop="deliveryContactTelephone"
          >
            <el-input
              :placeholder="
                this.$t('transportOrderAdd.transportForm.deliveryContactTelephonePlaceholder')
              "
              v-model="transportData.deliveryContactTelephone"
              clearable
              maxlength="32"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <!-- 运输数量 -->
        <el-col :span="6">
          <el-form-item
            :label="this.$t('transportOrderAdd.transportForm.deliveryQuantity')"
            prop="deliveryQuantity"
          >
            <!-- <input-number-ad
              :disabled="transportData.deliveryPackageNumber != ''"
              v-model="transportData.deliveryQuantity"
              :max="'999999999.999999'"
              :precision="$globalVar.qPoint"
              :placeholder="
                this.$t(
                  'transportOrderAdd.transportForm.deliveryQuantityPlaceholder'
                )
              "
              @change="val => packOrQuantity(val)"
            ></input-number-ad> -->
            <input-number-ad
              :disabled="transportData.deliveryPackageNumber != ''"
              v-model="transportData.deliveryQuantity"
              :max="'999999999.999999'"
              :precision="$globalVar.qPoint"
              :placeholder="this.$t('transportOrderAdd.transportForm.deliveryQuantityPlaceholder')"
              @change="(val) => packOrQuantity(val)"
              clearable
            ></input-number-ad>
          </el-form-item>
        </el-col>
        <!-- 运输件数 -->
        <el-col :span="6">
          <el-form-item
            :label="this.$t('transportOrderAdd.transportForm.deliveryPackageNumber')"
            prop="deliveryPackageNumber"
          >
            <!-- <el-form-item
            :label="
              this.$t('transportOrderAdd.transportForm.deliveryPackageNumber')
            "
            prop="deliveryPackageNumber"
            :required="isDeliveryPackageNumber"
          >
            <input-number-ad
              :disabled="transportData.deliveryQuantity != ''"
              v-model="transportData.deliveryPackageNumber"
              :max="'999999999.999999'"
              :precision="$globalVar.qPoint"
              :placeholder="
                this.$t(
                  'transportOrderAdd.transportForm.deliveryPackageNumberPlaceholder'
                )
              "
              @change="val => packOrQuantity(val)"
            ></input-number-ad> -->
            <input-number-ad
              :disabled="transportData.deliveryQuantity != ''"
              v-model="transportData.deliveryPackageNumber"
              :max="'999999999.999999'"
              :precision="$globalVar.qPoint"
              :placeholder="
                this.$t('transportOrderAdd.transportForm.deliveryPackageNumberPlaceholder')
              "
              @change="(val) => packOrQuantity(val)"
            ></input-number-ad>
          </el-form-item>
        </el-col>
        <!-- 运费单价 -->
        <el-col :span="6">
          <el-form-item
            :label="this.$t('transportOrderAdd.transportForm.deliveryExpenseUnitPrice')"
            prop="deliveryExpenseUnitPrice"
          >
            <input-number-ad
              v-model="transportData.deliveryExpenseUnitPrice"
              :max="'99999999999.999999'"
              :precision="$globalVar.pPoint"
              :placeholder="
                this.$t('transportOrderAdd.transportForm.deliveryExpenseUnitPricePlaceholder')
              "
              @change="(val) => packOrQuantity(val)"
            ></input-number-ad>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="this.$t('transportOrderAdd.transportForm.deliveryExpenseUnit')"
            prop="deliveryExpenseUnit"
          >
            <el-select
              clearable
              class="widthStyle"
              v-model="transportData.deliveryExpenseUnit"
              filterable
              remote
              reserve-keyword
              :placeholder="
                this.$t('transportOrderAdd.transportForm.deliveryExpenseUnitPlaceholder')
              "
              @change="changeUnit"
            >
              <el-option
                v-for="item in unitOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <!-- 运费总价 -->
        <el-col :span="6">
          <el-form-item
            :label="this.$t('transportOrderAdd.transportForm.deliveryExpenseTotalPrice')"
            prop="deliveryExpenseTotalPrice"
          >
            <input-number-ad
              disabled
              v-model="transportData.deliveryExpenseTotalPrice"
              :placeholder="
                this.$t('transportOrderAdd.transportForm.deliveryExpenseTotalPricePlaceholder')
              "
            ></input-number-ad>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="this.$t('transportOrderAdd.transportForm.otherExpense')"
            prop="otherExpense"
          >
            <input-number-ad
              v-model="transportData.otherExpense"
              :max="'99999999999.999999'"
              :placeholder="this.$t('transportOrderAdd.transportForm.otherExpensePlaceholder')"
              @change="(val) => packOrQuantity(val)"
            ></input-number-ad>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="this.$t('transportOrderAdd.transportForm.otherExpenseType')"
            prop="otherExpenseType"
          >
            <el-select
              class="widthStyle"
              :placeholder="this.$t('transportOrderAdd.transportForm.otherExpenseTypePlaceholder')"
              v-model="transportData.otherExpenseType"
              clearable
              filterable
            >
              <el-option
                v-for="item in otherExpenseTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 费用合计 -->
        <el-col :span="6">
          <el-form-item
            :label="this.$t('transportOrderAdd.transportForm.totalExpense')"
            prop="totalExpense"
          >
            <input-number-ad
              disabled
              v-model="transportData.totalExpense"
              :placeholder="this.$t('transportOrderAdd.transportForm.totalExpensePlaceholder')"
            ></input-number-ad>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item
            :label="this.$t('transportOrderAdd.transportForm.deliveryMethod')"
            prop="deliveryMethod"
          >
            <el-select
              class="widthStyle"
              :placeholder="this.$t('transportOrderAdd.transportForm.deliveryMethodPlaceholder')"
              v-model="transportData.deliveryMethod"
              clearable
              filterable
            >
              <el-option
                v-for="item in deliveryMethodOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="this.$t('transportOrderAdd.transportForm.settle')" prop="settle">
            <el-checkbox disabled v-model="transportData.settle"></el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="this.$t('transportOrderAdd.transportForm.expenseMark')"
            prop="expenseMark"
          >
            <el-input
              :placeholder="this.$t('transportOrderAdd.transportForm.expenseMarkPlaceholder')"
              v-model="transportData.expenseMark"
              clearable
              maxlength="128"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- 运输载具数据表格 -->
    <vxe-toolbar>
      <template v-slot:buttons>
        <vxe-button
          type="primary"
          icon="el-icon-plus"
          class="vxe-btn-primary"
          @click="insertEvent()"
          v-if="status != 3 && status != 4"
          >{{ $t('transportOrderAdd.btnList.add') }}</vxe-button
        >
        <vxe-button
          type="primary"
          icon="el-icon-delete"
          class="vxe-btn-delete"
          @click="handleDelete('transTable')"
          v-if="status != 3 && status != 4"
          >{{ $t('transportOrderAdd.btnList.remove') }}</vxe-button
        >
      </template>
    </vxe-toolbar>
    <vxe-table
      border
      resizable
      show-overflow
      :data="deliveryTransport"
      :edit-config="editConfig"
      size="mini"
      ref="transTable"
      :edit-rules="transTableEditRules"
      auto-resize
    >
      <vxe-table-column type="checkbox" width="60"></vxe-table-column>
      <vxe-table-column
        field="nameVoyageLicense"
        :title="this.$t('transportOrderAdd.transTable.transNum')"
        :edit-render="{
          name: 'ElInput',
          events: { keydown: changeEvent },
          defaultValue: '',
          props: { clearable: true },
          maxlength: '32',
        }"
      ></vxe-table-column>
      <vxe-table-column
        field="freightInformation"
        :title="this.$t('transportOrderAdd.transTable.freightInfo')"
        :edit-render="{
          name: 'ElInput',
          events: { keydown: changeEvent },
          defaultValue: '',
          props: { clearable: true },
          maxlength: '32',
        }"
      ></vxe-table-column>
      <vxe-table-column
        field="contactPerson"
        :title="this.$t('transportOrderAdd.transTable.linkMan')"
        :edit-render="{
          name: 'ElInput',
          events: { keydown: changeEvent },
          defaultValue: '',
          props: { clearable: true },
          maxlength: '32',
        }"
      ></vxe-table-column>
      <vxe-table-column
        field="contactPhoneNo"
        :title="this.$t('transportOrderAdd.transTable.contactWay')"
        :edit-render="{
          name: 'ElInput',
          events: { keydown: changeEvent },
          defaultValue: '',
          props: { clearable: true },
          maxlength: '32',
        }"
      ></vxe-table-column>
      <vxe-table-column
        field="identityCardNumber"
        :title="this.$t('transportOrderAdd.transTable.idNumber')"
        :edit-render="{
          name: 'ElInput',
          events: { keydown: changeEvent },
          defaultValue: '',
          props: { clearable: true },
          maxlength: '32',
        }"
      ></vxe-table-column>
    </vxe-table>
  </div>
</template>
<script>
  import searchTable from '@/components/form-item/search-table';
  import GOODS_API from '@/api/masterData/goods';
  import { mapState } from 'vuex';
  import CAL_API from '@/api/purchaseSalesCenter/salesReturnsAndExchange';
  import inputNumberAd from '@/components/form-item/input-number-advance';

  export default {
    name: 'transportForm',
    components: {
      searchTable,
      inputNumberAd,
    },
    props: ['isEdit', 'allDetail', 'status'],
    mounted() {
      this.editConfig =
        this.status != 3 && this.status != 4
          ? { trigger: 'click', mode: 'row', showStatus: true }
          : {};
      this.getDictSelect();
    },
    watch: {
      // 判断表格编辑功能是否禁用
      status: function (newQuestion) {
        this.editConfig =
          newQuestion != 3 && newQuestion != 4
            ? { trigger: 'click', mode: 'row', showStatus: true }
            : {};
      },
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        unitOptions(state) {
          if (state.dict.dictList.length > 10) {
            return state.dict.dictList.find((it) => it.dictType == 'basic_unit').dictList;
          }
        },
      }),
      transportDataRules() {
        // 验证运输数量和运输件数两选一必填
        // let validate = (rule, value, callback) => {
        //   if (
        //     this.transportData.deliveryQuantity === "" &&
        //     this.transportData.deliveryPackageNumber === ""
        //   ) {
        //     if (rule.field == "deliveryQuantity") {
        //       callback(
        //         new Error(
        //           this.$t(
        //             "transportOrderAdd.transportForm.deliveryQuantityPlaceholder"
        //           )
        //         )
        //       );
        //     } else if (rule.field == "deliveryPackageNumber") {
        //       callback(
        //         new Error(
        //           this.$t(
        //             "transportOrderAdd.transportForm.deliveryPackageNumberPlaceholder"
        //           )
        //         )
        //       );
        //     }
        //   } else {
        //     callback();
        //   }
        // };
        return {
          // carrierName: [
          //   {
          //     required: true,
          //     message: this.$t(
          //       "transportOrderAdd.transportForm.carrierNamePlaceholder"
          //     ),
          //     trigger:  ["blur", "change"]
          //   }
          // ],
          // deliveryProductNo: [
          //   {
          //     required: true,
          //     message: this.$t(
          //       "transportOrderAdd.transportForm.deliveryProductNoPlaceholder"
          //     ),
          //     trigger: "blur"
          //   }
          // ],
          // deliveryQuantity: [
          //   {
          //     required: false,
          //     message: this.$t(
          //       "transportOrderAdd.transportForm.deliveryQuantityPlaceholder"
          //     ),
          //     trigger: "blur"
          //   }
          // ],
          // deliveryQuantity: [{ validator: validate }],
          // deliveryPackageNumber: [{ validator: validate }]
        };
      },
      transTableEditRules() {
        var idCardValidate = (rule, value, callback) => {
          let reg1 = /^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}$/; //第一代身份证
          let reg2 =
            /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/; //第二代身份证
          if (
            value &&
            (value.length != 15 || !reg1.test(value)) &&
            (value.length != 18 || !reg2.test(value))
          ) {
            callback(new Error('请输入正确的身份证号'));
          } else {
            callback();
          }
        };
        return {
          nameVoyageLicense: [
            {
              required: true,
              message: this.$t('transportOrderAdd.transTableRules.nameVoyageLicense'),
              trigger: ['blur', 'change'],
            },
          ],
          contactPerson: [
            {
              required: true,
              message: this.$t('transportOrderAdd.transTableRules.contactPerson'),
              trigger: ['blur', 'change'],
            },
          ],
          contactPhoneNo: [
            {
              required: true,
              message: this.$t('transportOrderAdd.transTableRules.contactPhoneNo'),
              trigger: ['blur'],
            },
          ],
          identityCardNumber: [
            {
              validator: idCardValidate,
            },
            // {
            //   required: true,
            //   message: this.$t(
            //     "transportOrderAdd.transTableRules.identityCardNumber"
            //   ),
            //   trigger: ["blur", "change"]
            // }
          ],
        };
      },
    },
    data() {
      return {
        editConfig: {},
        // 顶部表单
        transportData: {
          carrierNo: '',
          carrierName: '',
          deliveryProductNo: '',
          deliveryContactPerson: '',
          deliveryContactTelephone: '',
          deliveryQuantity: '',
          deliveryPackageNumber: '',
          deliveryExpenseUnitPrice: '',
          deliveryExpenseUnit: 'T',
          deliveryExpenseUnitName: '吨',
          deliveryExpenseTotalPrice: '',
          otherExpense: '',
          otherExpenseType: '',
          totalExpense: '',
          deliveryMethod: '',
          settle: false,
          expenseMark: '',
        },
        isDeliveryQuantity: true,
        isDeliveryPackageNumber: true,
        deliveryTransport: [], //运输信息表格
        deliveryMethodOptions: [], //运输试试下拉数据
        otherExpenseTypeOptions: [], //其他费用类型下拉数据
        deleteDeliveryTransportList: [], //删除的载具信息id的集合
        deliveryTransportStr: [], //新增的载具信息(转成String传)
        updateDeliveryTransportStr: [], //修改的载具信息(转成String传)
      };
    },
    methods: {
      setSearchModalInput(val) {
        this.transportData.carrierName = val;
      },
      setSearchModal(val) {
        this.transportData.carrierName = val ? val[0].partnerZhName : null;
      },
      getDeatil(allDetail) {
        if (this.status != 0) {
          let transportData = {};
          Object.keys(this.transportData).forEach((item) => {
            if (item == 'carrierName') {
              if (allDetail.delivery[`${item}`]) {
                // let obj = {
                //   partnerZhName: allDetail.delivery[`${item}`],
                // };
                transportData[`${item}`] = allDetail.delivery[`${item}`] || '';
              } else {
                transportData[`${item}`] = '';
              }
            } else {
              transportData[`${item}`] = allDetail.delivery[`${item}`] || '';
            }
          });
          this.transportData = transportData;
          this.deliveryTransport = allDetail.deliveryTransportList;
          this.packOrQuantity();
        }
      },
      changeEvent(columnm) {
        if (columnm.row.id) {
          if (this.updateDeliveryTransportStr.length != 0) {
            let flag = true;
            this.updateDeliveryTransportStr.map((item) => {
              if (item.id == columnm.row.id) {
                flag = false;
              }
            });
            if (flag) {
              this.updateDeliveryTransportStr.push(columnm.row);
            }
          } else {
            this.updateDeliveryTransportStr.push(columnm.row);
          }
        }
      },
      // 获取单位名称
      changeUnit(val) {
        this.unitOptions.map((item) => {
          if (item.value == val) {
            this.transportData.deliveryExpenseUnitName = item.label;
          }
        });
      },
      getDictSelect() {
        //通过数据字典获取运输方式下拉
        this.$axios
          .post(GOODS_API.DATA_DICT, {
            dictType: 'delivery_method',
            tenantCode: this.userInfo.tenantCode,
          })
          .then((res) => {
            if (res.data.code === 0) {
              this.deliveryMethodOptions = res.data.data;
            }
          });
        //通过数据字典获取基本单位下拉
        this.$axios
          .post(GOODS_API.DATA_DICT, {
            dictType: 'other_expense_type',
            tenantCode: this.userInfo.tenantCode,
          })
          .then((res) => {
            if (res.data.code === 0) {
              this.otherExpenseTypeOptions = res.data.data;
            }
          });
      },
      packOrQuantity() {
        if (this.transportData.deliveryQuantity != '') {
          this.isDeliveryQuantity = true;
          this.isDeliveryPackageNumber = false;
        } else if (this.transportData.deliveryPackageNumber != '') {
          this.isDeliveryQuantity = false;
          this.isDeliveryPackageNumber = true;
        } else if (
          this.transportData.deliveryPackageNumber == '' &&
          this.transportData.deliveryQuantity == ''
        ) {
          this.isDeliveryQuantity = true;
          this.isDeliveryPackageNumber = true;
        }
        this.$refs.transportForm.clearValidate(['deliveryQuantity', 'deliveryPackageNumber']);
        const params = {
          returnQuantity:
            this.transportData.deliveryQuantity || this.transportData.deliveryPackageNumber || 0,
          returnUnitPrice: this.transportData.deliveryExpenseUnitPrice
            ? this.transportData.deliveryExpenseUnitPrice
            : 0,
        };
        this.$axios.post(CAL_API.GET_RETURN_MONEY_AMOUNT, params).then((res) => {
          if (0 == res.data.code) {
            this.transportData.deliveryExpenseTotalPrice = res.data.data.returnMoneyAmount;
            let query = {
              adds: [
                this.transportData.deliveryExpenseTotalPrice || 0,
                this.transportData.otherExpense || 0,
              ],
            };
            this.$axios.post(CAL_API.GET_ADD_AMOUNT, query).then((res) => {
              if (0 == res.data.code) {
                this.transportData.totalExpense = res.data.data;
              } else {
                this.$message({
                  showClose: true,
                  message: res.data.msg,
                  type: 'error',
                });
              }
            });
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      // 载具表格新增一行
      insertEvent() {
        this.$refs.transTable.validate((valid) => {
          if (valid) {
            const record = {
              nameVoyageLicense: null,
              freightInformation: null,
              contactPerson: null,
              contactPhoneNo: null,
              identityCardNumber: null,
            };
            this.$refs.transTable
              .insert(record)
              .then(({ row }) => this.$refs.transTable.setActiveRow(row));
          }
        });
      },
      handleDelete(transTable) {
        const selectedList = this.$refs[transTable].getCheckboxRecords();
        this.deleteDeliveryTransportList = [...this.deleteDeliveryTransportList, ...selectedList];
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: '您还没选择想要删除的数据',
            type: 'error',
          });
          return;
        }
        this.$confirmAction()
          .then(() => {
            this.$refs[transTable].removeSelecteds();
            this.deliveryTransport = this.$refs.transTable.getTableData().fullData;
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('personnel.table.deletSuccess'),
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('personnel.table.deletFalse'),
            });
          });
      },
      // 返回数据
      exportChildData(btnType) {
        this.transportData.deleteDeliveryTransportList = [];
        this.deliveryTransportStr = []; //新增的载具信息(转成String传)
        this.transportData.deliveryTransportList = this.$refs.transTable.getTableData().fullData;
        this.$refs.transTable.getTableData().fullData.map((item) => {
          if (item.id == undefined) {
            this.deliveryTransportStr.push(JSON.stringify(item));
          }
        });
        //删除的载具信息id的集合
        this.deleteDeliveryTransportList.map((item) => {
          if (item.id) {
            this.transportData.deleteDeliveryTransportList.push(item.id);
          }
        });
        //新增的载具信息(转成String传)
        this.transportData.deliveryTransportStr = '[' + this.deliveryTransportStr.join(',') + ']';
        //修改的载具信息(转成String传)、
        this.transportData.updateDeliveryTransportStr = this.updateDeliveryTransportStr;
        this.updateDeliveryTransportStr.map((item, index) => {
          let id = item.id;
          let idIndex = index;
          this.deleteDeliveryTransportList.map((item) => {
            if (item.id == id) {
              this.transportData.updateDeliveryTransportStr.splice(idIndex, 1);
            }
          });
        });
        let updateList = [];
        this.transportData.updateDeliveryTransportStr.map((item) => {
          updateList.push(JSON.stringify(item));
        });
        this.transportData.updateDeliveryTransportStr = '[' + updateList + ']';
        if (btnType != '2') {
          // let formList = ['transportForm', 'transTable'];
          let promiseObjectList = [];
          // let _self = this;
          // function validates(formName) {
          //   let promiseObject = new Promise((resolve, reject) => {
          //     _self.$refs[formName].validate((valid) => {
          //       valid ? resolve() : reject();
          //     });
          //   });
          //   promiseObjectList.push(promiseObject);
          // }
          // formList.forEach((item) => {
          //   validates(item); // 循环校验
          // });
          return Promise.all(promiseObjectList).then(() => {
            return this.transportData;
          });
        } else {
          return this.transportData;
        }
      },
    },
  };
</script>
<style lang="scss" scoped>
  .transportForm .widthStyle {
    width: 100%;
  }
</style>
